import React from 'react';
import { IoIosStar, IoIosStarOutline } from 'react-icons/io';
import { layout } from 'styled-system';
import { Colors, styled } from 'themes';
import { Box, Flex } from 'components';

const StarRating = props => {
  const { rating, size = [18] } = props;

  return (
    <Flex>
      {[1, 2, 3, 4, 5].map(number => {
        return (
          <IconWrapper key={number} mr={[1]} height={size}>
            {rating >= number ? (
              <IoIosStar size={size} color={Colors.darkOrange} />
            ) : (
              <IoIosStarOutline size={size} color={Colors.darkOrange} />
            )}
          </IconWrapper>
        );
      })}
    </Flex>
  );
};

const IconWrapper = styled(Box)`
  ${layout};
`;

export default StarRating;
